import { Drawer } from '@mui/material';
import { styled } from '@mui/material';
import type { Theme } from '@mui/material/styles';

import { Button } from '~/components/ui/button';
import { TABLET_MIN_WIDTH } from '~/constants/common';
import { StyledBlock } from '~/pages/HomePage/components/AnonymousQR/styled';
import { COLORS } from '~/styles/colors';

// Define prop types
interface SelectedProps {
  $isSelected?: boolean;
}

interface SelectedMoreProps extends SelectedProps {
  $isMore?: boolean;
}

export const StyledMobileBlock = styled(StyledBlock)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px 8px',
}));

export const StyledMobileBlockTop = styled(StyledMobileBlock)(({ theme }: { theme: Theme }) => ({
  position: 'relative',
  img: {
    width: '136px',
  },
  [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
    img: {
      width: '100px',
    },
  },
}));

export const StyledTabs = styled('div')(({ theme }: { theme: Theme }) => ({
  padding: '4px',
  display: 'flex',
  gap: '2px',
  backgroundColor: COLORS.grey100,
  border: `1px solid ${COLORS.grey200}`,
  borderRadius: '16px',
  marginBottom: '12px',
  [theme.breakpoints.down(400)]: {
    width: '100%',
  },
}));

export const StyledTab = styled('button')<SelectedProps>(({ $isSelected }) => ({
  borderRadius: '12px',
  backgroundColor: $isSelected ? COLORS.primary : COLORS.grey100,
  flex: 1,
  width: '156px',
  padding: '6px 10px',
  border: 'none',
  color: $isSelected ? COLORS.white : COLORS.grey400,
  fontSize: '14px',
  lineHeight: '19.07px',
  fontWeight: 500,
  cursor: 'pointer',
}));

export const StyledQRTypeButton = styled('button')(() => ({
  width: '100%',
  border: `1px solid ${COLORS.primary}`,
  backgroundColor: COLORS.blue50,
  display: 'flex',
  gap: '6px',
  borderRadius: '100px',
  padding: '10px 16px',
  alignItems: 'center',
}));

export const StyledDivider = styled('hr')(() => ({
  marginBottom: '16px',
  border: `1px solid ${COLORS.grey200}`,
  width: '100%',
}));

export const StyledQRTypeItem = styled('button')<SelectedProps>(({ $isSelected }) => ({
  backgroundColor: $isSelected ? COLORS.blue50 : COLORS.white,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
  boxSizing: 'border-box',
  padding: '4px 12px',
  cursor: 'pointer',
  gap: '6px',
  '&:not(:last-of-type)': {
    marginTop: '4px',
  },
  border: 'none',
}));

export const StyledQRTypeItemIconContainer = styled('div')<SelectedMoreProps>(({ $isSelected, $isMore }) => ({
  width: '44px',
  height: '44px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  border: `1px solid ${$isSelected || $isMore ? COLORS.primary : COLORS.grey400}`,
  borderRadius: '12px',
  boxSizing: 'border-box',
  padding: '4px',
  backgroundColor: $isMore ? COLORS.primary : undefined,
}));

export const StyledDrawer = styled(Drawer)(() => ({
  '& .MuiDrawer-paper': {
    padding: '20px 10px',
    borderRadius: '20px 20px 0 0',
  },
  '& .MuiBackdrop-root': {
    backdropFilter: 'blur(2px)',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
  },
}));

export const StyledBottomButton = styled(Button)(() => ({
  padding: '10px 44px !important',
  margin: '28px auto 0',
}));

export const StyledAvailableTemplateContainer = styled('div')(() => ({
  marginTop: '24px',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
}));
